module.exports = __webpack_public_path__ + "static/img/WechatIMG148.f8b3e7da.png";